import { useEffect, useState } from 'react'
import { DataElement } from '../..'
import style from './style.module.scss'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import DeleteIcon from '@mui/icons-material/Delete'
import { Reorder } from 'framer-motion'

type EditorStructureProps = {
  content: DataElement[]
  onUpdate: (data: Structure) => void
  updateSelected: (index: number | null) => void
  selectedIndex: number | null
}

export type Structure = {
  type: string
  id: string
}[]

const EditorStructure = ({ content, onUpdate, updateSelected, selectedIndex }: EditorStructureProps) => {
  const [contentStructure, setContentStructure] = useState<Structure>(
    content.map((element) => ({ type: element.type, id: element.props.id }))
  )

  useEffect(() => {
    if (content.length !== contentStructure.length) {
      setContentStructure(content.map((element) => ({ type: element.type, id: element.props.id })))
    }
  }, [content])

  useEffect(() => {
    onUpdate(contentStructure)
  }, [contentStructure])

  const handleDeleteElement = (id: string) => {
    const newContent = contentStructure.filter((element) => element.id !== id)
    setContentStructure(newContent)
    updateSelected(null)
    onUpdate(newContent)
  }

  const handleSelectElement = (index: number) => {
    updateSelected(index)
  }

  return (
    <Reorder.Group values={contentStructure} onReorder={setContentStructure} className={style.structure_list}>
      {contentStructure.map((element, i) => {
        return (
          <Reorder.Item
            value={element}
            key={element.id}
            className={style.structure_item + (selectedIndex === i ? ' ' + style.selected : '')}
            title={element.id}
            onClick={() => handleSelectElement(i)}
          >
            <DragIndicatorIcon className={style.drag_icon} />
            <p>{element.type}</p>
            <DeleteIcon className={style.delete_icon} onClick={() => handleDeleteElement(element.id)} />
          </Reorder.Item>
        )
      })}
    </Reorder.Group>
  )
}

export default EditorStructure
